import { styled } from '@mui/material';
import { Widget } from '@typeform/embed-react';

export const TypeformWidget = styled(Widget)({
  width: '100%',
  minHeight: '60vh'
});
